import FieldError from "../../../components/ui/FieldError";
import { useEffect, useRef, useState } from "react";
import axiosConfig from "../../../services/Axios";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/pro-light-svg-icons";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function EditQuantity({ orderItem }) {
  const form = useForm();
  const formSubmitBtn = useRef();
  const [quantity, setQuantity] = useState(orderItem.quantity);
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    const datas = {
      quantity: parseInt(quantity),
      initQuantity: orderItem.initQuantity,
    };

    if (!quantity) return;
    try {
      await axiosConfig
        .patch(process.env.REACT_APP_API_URL + orderItem["@id"], datas, {
          headers: { "Content-Type": "application/merge-patch+json" },
        })
        .then((response) => {
          if (response?.status === 200 && response?.data) {
            toast.success(t("settings.orders.orderItems.updated"), {
              theme: "colored",
              hideProgressBar: true,
            });
          }
        });
    } catch (e) {
      if (e.response?.status !== 200) {
        if (e.response.data?.violations) {
          e.response.data.violations.map((v) => {
            form.setError(v.propertyPath, {
              type: "manual",
              message: v.message,
            });
          });
        } else {
          toast.error(e.response.data["hydra:description"], {
            theme: "colored",
            hideProgressBar: true,
          });
        }
      }
    }
  };

  let timeout;
  useEffect(() => {
    if (quantity !== orderItem.quantity) {
      timeout = setTimeout(() => {
        formSubmitBtn.current.click();
      }, 350);
    }
    return () => clearTimeout(timeout);
  }, [quantity]);

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <input
          {...form.register("quantity", {
            valueAsNumber: true,
            required: t("settings.orders.orderItems.quantityRequired"),
          })}
          name="quantity"
          type="number"
          className="w-3/6 rounded-l text-center h-10"
          defaultValue={orderItem.quantity}
          min="0"
          max={orderItem.item?.itemPackage?.quantity}
          onChange={(event) => setQuantity(event.target.value)}
          aria-invalid={form.formState?.errors?.quantity ? true : false}
        />
        <input type="submit" className="hidden" ref={formSubmitBtn} />
        <FieldError error={form.formState?.errors?.quantity} />
      </form>
      {quantity && quantity !== orderItem.initQuantity && (
        <div className="text-xs text-center italic text-bioport-orange-dark">
          {t("settings.orders.orderItems.initQuantity", {
            initQuantity: orderItem.initQuantity,
          })}
        </div>
      )}
    </>
  );
}

export default EditQuantity;
